export default "__VITE_ASSET__f253d14e__"